import { DaySummaryModel } from "./day-summary.model"
import { MonthSummaryModel } from "./month-summary.model";
import { PoSummaryForOperationModel } from "./po-summary.model";


export class DayMonthPoOperationSummaryModel {
    poWiseSummary: PoSummaryForOperationModel[];
    monthSummary: MonthSummaryModel;
    todaySummary: DaySummaryModel;

    constructor(poWiseSummary: PoSummaryForOperationModel[], monthSummary: MonthSummaryModel, todaySummary: DaySummaryModel) {
        this.poWiseSummary = poWiseSummary;
        this.monthSummary = monthSummary;
        this.todaySummary = todaySummary;
    }
}